export default __webpack_public_path__ + "static/media/import.1f2a5768.svg";